import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import '@/assets/styles.css';
import { setupI18n } from './i18n';

async function bootstrap() {
	const i18n = await setupI18n();
	const app = createApp(App);
	app.use(i18n);
	app.use(router);
	app.mount('#app');
}
bootstrap();
